import PropTypes from 'prop-types';
import React from 'react';

const TableBody = (props) => <tbody {...props}>{props.children}</tbody>;

TableBody.propTypes = {
  children: PropTypes.any,
};

export default TableBody;
